import QuizCreation from '@/shared-components/forms/add-board-content/board-text-body/add-element/add-quiz/QuizCreation';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';

import { handleGenericEdit,handleGenericSubmit } from '../../utils';

import QuizDisplay from './QuizDisplay';

export default function QuizManager({
  formState,
  setFormState,
  editableRef,
  isQuizModalOpen,
  setIsQuizModalOpen,
  handleQuizEdit,
  quizToEdit,
  setQuizToEdit,
  textEditorSelector,
  removeQuizFromDom,
}) {
  const handleClose = () => {
    setIsQuizModalOpen(false);
    setQuizToEdit(null);
  };

  const handleDelete = () => {
    if (!quizToEdit) return;
    removeQuizFromDom(quizToEdit.quizId);
    handleClose();
  };

  const handleQuizSubmit = (data) => {
    const newId   = (formState.post_quizzes?.length || 0) + 1;

    const newQuiz = {
      quizId: newId,
      question: data.question,
      options: data.options,
      correctOption: data.correctOption
    };

    const quizzes = [...formState.post_quizzes, newQuiz];

    setFormState(prev => ({
      ...prev,
      post_quizzes: quizzes,
    }));

    const containerId = `quiz-${newId}`;
    
    handleGenericSubmit(textEditorSelector, editableRef, containerId,
      <QuizDisplay
        quizId={newId}
        question={data.question}
        options={data.options}
        correctOption={data.correctOption}
        previewMode={false}
        disableSelection={true}
        initialHasAnswered={false}
        userAnswer={null}
        onAnswer={undefined}
        onEditClick={() => handleQuizEdit(newId, quizzes)}
      />);

    setIsQuizModalOpen(false);
  };

  const handleQuizUpdate = (updated) => {
    if (!quizToEdit) return;
    const id = quizToEdit.quizId;

    setFormState(prev => {
      const quizzes = prev.post_quizzes.map(quizz => ({
        ...quizz,
        ...updated,
      }));

      const containerId = `quiz-${id}`;

      handleGenericEdit(containerId,
        <QuizDisplay
          quizId={id}
          question={updated.question}
          options={updated.options}
          correctOption={updated.correctOption}
          previewMode={false}
          disableSelection={true}
          initialHasAnswered={false}
          userAnswer={null}
          onAnswer={undefined}
          onEditClick={() => handleQuizEdit(id, quizzes)}
          hasAnybodyAnswered={updated.hasAnybodyAnswered}
        />
      );

      return {
        ...prev,
        post_quizzes: quizzes,
      };
    });

    setQuizToEdit(null);
    setIsQuizModalOpen(false);
  };

  return (
    <>
      {isQuizModalOpen && (
        <GenericPopup
          className="poll-quiz-creation-popup remove-scrollbar"
          open={isQuizModalOpen}
          opacity
          onBackgroundClick={handleClose}
        >
          <QuizCreation
            key={quizToEdit ? `quiz-edit-${quizToEdit.id}` : 'quiz-new'}
            initialQuizData={quizToEdit}
            onSubmit={quizToEdit ? handleQuizUpdate : handleQuizSubmit}
            onClose={handleClose}
            onDelete={quizToEdit ? handleDelete : undefined}
          />
        </GenericPopup>
      )}
    </>
  );
}
